// Web Edition filesystem adapter.
// Import via the File System Access API / paste; the plan is applied by
// exporting a shell script (the browser cannot reliably perform every large
// recursive rename directly), so script export stays the primary workflow.

export const webAdapter = {
  id: "web",
  label: "Web",
  canImportFolder: true,
  canApplyDirect: false,
  exportPrimary: true,
  importVerb: "Open Folder",
};
